import {
  Component,
  OnInit,
  ViewEncapsulation,
  OnDestroy,
  Injector,
} from '@angular/core';
import { BaseGridComponent } from '../../base-grid/base-grid.component';
import { Subscription } from 'rxjs';
import { ColumnList } from '../../constants/column-list.const';
import { SelectionResults } from '../../../models/selection-results/selection-results.model';
import { ValidSize } from '../../../models/selection-results/valid-size.model';
@Component({
    selector: 'circulator-ddf-grid',
    templateUrl: '../../base-grid/base-grid.component.html',
    styleUrls: ['../../base-grid/base-grid.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CirculatorDDFGridComponent
  extends BaseGridComponent
  implements OnInit, OnDestroy
{
  private selectionResultsSubscription: Subscription;

  constructor(protected injector: Injector) {
    super(injector);

    this.gridSaveKey = '';
  }

  ngOnInit() {
    const selectionMethodQuestion =
      this.layoutConfig.getQuestion('selectionMethod');

    const selectionMethod = !!selectionMethodQuestion
      ? selectionMethodQuestion.value
      : 'ByFanSize';

    this.gridSaveKey =
      selectionMethod === 'ByFanSize'
        ? 'circulatorDDFSizeBased'
        : 'circulatorDDFPerformanceBased';

    this.showRank = selectionMethod === 'ByPerformance';

    const colList =
      selectionMethod === 'ByFanSize'
        ? //size
          [
            'budgetPrice',
            'maxCFM',
            'avgAirSpeedMax',
            'operatingCost',
            'speedMax',
            'motorHP',
            'outletDba',
            'weight',
            'directionOfOperation',
            'affectedArea',
            'wheelDiameter',
            'motorHPWatts',
            'watts',
            'minFanSpacing',
          ]
        : //performance
          [
            'fanQuantity',
            'budgetPrice',
            'actualCFM',
            'avgAirSpeed',
            'operatingCost',
            'fanRPM',
            'motorHP',
            'outletDba',
            'weight',
            'affectedArea',
            'directionOfOperation',
            'wheelDiameter',
            'minFanSpacing',
            'speedMax',
            'motorHPWatts',
            'watts',
            'actualFanSpacing',
          ];
    const visibleColumnList =
      selectionMethod === 'ByFanSize'
        ? //size
          [
            'budgetPrice',
            'maxCFM',
            'avgAirSpeedMax',
            'operatingCost',
            'speedMax',
            'motorHP',
            'outletDba',
            'weight',
          ]
        : //performance
          [
            'fanQuantity',
            'budgetPrice',
            'actualCFM',
            'avgAirSpeed',
            'operatingCost',
            'fanRPM',
            'motorHP',
            'outletDba',
            'weight',
            'affectedArea',
          ];

    this.columnList = ColumnList.getColumns(...colList);

    this.columnList.find((item) => item.key === 'speedMax').text =
      'Max. Fan RPM';

    this.columnList.find((item) => item.key === 'watts').text =
      'Input Watts Per Fan';

    this.columnList.find((item) => item.key === 'wheelDiameter').text =
      'Fan Diameter (in.)';

    this.columnList.find((item) => item.key === 'operatingCost').text =
      'Total Operating Cost/yr (USD)';

    this.columnList.find((item) => item.key === 'outletDba').text =
      'Total dBA Per Fan';

    this.columnList.find((item) => item.key === 'weight').text =
      'Wt. (lbs) Per Fan';

    if (selectionMethod === 'ByPerformance') {
      this.columnList.find((item) => item.key === 'actualCFM').text =
        'Actual CFM per Fan';

      this.columnList.find((item) => item.key === 'watts').text =
        'Input Watts Per Fan';
    } else {
      this.columnList.find((item) => item.key === 'affectedArea').text =
        'Max. Coverage Area per Fan (sq ft)';
    }

    this.setVisibleColumns(visibleColumnList);

    this.selectionResultsSubscription = this.selectionResultsReceived.subscribe(
      (selectionResults: SelectionResults) => {
        const newData = [];

        selectionResults.validSizes.forEach((size) => {
          newData.push(this.validSizeToDSRow(size));
        });

        this.dataSource.data = newData;
      }
    );

    this.loadVisibleColumns();

    this.updateColumnHelp();
  }

  ngOnDestroy() {
    super.ngOnDestroy();

    this.selectionResultsSubscription.unsubscribe();
  }

  private validSizeToDSRow(size: ValidSize) {
    const rowData = {
      rank: size.sorting.recommendedOrder,
      name: size.name,
      budgetPrice: size.pricing.price,
      affectedArea: size.outputs.affectedArea,
      minFanSpacing: size.outputs.minimumFanSpacing,
      actualFanSpacing: size.outputs.actualFanSpacing,
      operatingCost: size.outputs.operatingCostPerYear,
      fanRPM: size.outputs.speed,
      speedMax: size.outputs.speedMax,
      motorHP: size.outputs.motorSize,
      motorHPWatts: size.outputs.minimumMotorSizeNEMA,
      fanEfficiency: size.outputs.fanEfficiency,
      outletDba: size.outputs.outletdBA,
      weight: size.pricing.weight,
      wheelDiameter: size.outputs.impellerDiameter,
      directionOfOperation: size.outputs.directionOfOperation,
      maxCFM: size.outputs.maximumVolume,
      fanQuantity: size.outputs.fanQuantity,
      actualCFM: size.outputs.operatingVolume,
      watts: size.outputs.watts,
      avgAirSpeed: size.outputs.averageAirSpeed,
      avgAirSpeedMax: size.outputs.maximumAverageAirSpeed,
      coolingEffect: size.outputs.coolingEffect,
      stable: size.stability.stable,
      sizeData: size,
    };

    return rowData;
  }
}
